import {
	START_UPLOAD_PROCESS,
	FAIL_UPLOAD_DATA,
	SUCCESS_UPLOAD_DATA,
	SET_UPLOAD_LIST,
	SAVE_UPLOAD_CSV,
	FAIL_SAVE_UPLOAD_CSV,
	SUCCESS_SAVE_UPLOAD_CSV,
	RESET_UPLOAD_STATE,
	GET_CSV_TEMPLATE,
	FAIL_GET_CSV_TEMPLATE,
	SUCCESS_GET_CSV_TEMPLATE,
	RESET_PROCESS_ERROR,
	FETCH_CSV_TEMPLATE_INFO,
	FAIL_FETCH_CSV_TEMPLATE_INFO,
	SUCCESS_FETCH_CSV_TEMPLATE_INFO
} from '../actions';
import _ from 'lodash';


import {downloadCsvData} from '../common/utils/download-csv';

const initialState = {
	isFetching: false,
	isSaving:false,
	isCompleteSave:false,
	lastFileManageNO:0,
	uploadList:[],
	saveFileList:[],
	isProcessError : false,
	csvTemplateList : [],
};
export default function uploadSettings(state = initialState, action) {
	let ret = Object.assign({}, state,{});
	switch (action.type) {
		case START_UPLOAD_PROCESS:
			ret.isFetching = true;
			return ret;
		case FAIL_UPLOAD_DATA:
			ret.isFetching = false;
			ret.error = action.payload.err;
			ret.isProcessError = true;

			return ret;
		case SUCCESS_UPLOAD_DATA:
			const index = ret.uploadList.findIndex((list,index) => {
				return (list["FILE_MANAGE_NO"] === action.payload.results["file_manage_no"])
			});
			if(action.payload.results["error_data"].length){
				ret.uploadList[index]["STATUS"] = "RECORD_NG";
				ret.uploadList[index]["ERROR_DET"] = _.sortBy(action.payload.results["error_data"], 'RowNO');
				ret.uploadList[index]["MSG"] = action.payload.message;
			}
			else{
				if("ignore_data" in action.payload.results && action.payload.results["ignore_data"].length){
					ret.uploadList[index]["IGNORE_DET"] = _.sortBy(action.payload.results["ignore_data"], 'RowNO');
				}
				if("cutout_data" in action.payload.results && action.payload.results["cutout_data"].length){
					ret.uploadList[index]["CUTOUT_DET"] = _.sortBy(action.payload.results["cutout_data"], 'RowNO');
				}
				ret.uploadList[index]["UPLOAD_DET"] = action.payload.results["success_data"];
				ret.uploadList[index]["STATUS"] = "OK";
			}
			ret.isFetching = false;
			return ret;
		case SET_UPLOAD_LIST:
			return Object.assign({}, state, action.payload);
		case SAVE_UPLOAD_CSV:
			ret.isSaving = true;
			return ret;
		case FAIL_SAVE_UPLOAD_CSV:
			ret.isSaving = false;
			ret.error = action.payload.err;
			ret.isProcessError = true;
			return ret;
		case SUCCESS_SAVE_UPLOAD_CSV:
			ret.isSaving = false;
			ret.isCompleteSave = true;
			const sl = _.filter(ret.uploadList,(item)=>{
				return _.includes(item.STATUS, 'OK');
			});
			let saveFileList = [];
			let n = 0;
			sl.forEach((file)=>{
				const file_name = file.FILES["name"];
				file.UPLOAD_DET.forEach(data=>{
					data["id"] = n;
					data["FileName"] = file_name;
					saveFileList.push(data);
					n++;
				})
			});

			ret.saveFileList = saveFileList;

			ret.uploadList = [];
			ret.lastFileManageNO = 0;
			return ret;
		case RESET_UPLOAD_STATE:
			ret.saveFileList = [];
			ret.isCompleteSave = false;
			return ret;
		case GET_CSV_TEMPLATE:
			ret.isFetching = true;
			return ret;
		case FAIL_GET_CSV_TEMPLATE:
			ret.isFetching = false;
			ret.error = action.payload.err;
			ret.isProcessError = true;
			return ret;
		case SUCCESS_GET_CSV_TEMPLATE:
			const columns = action.payload.columns;
			downloadCsvData("upload_template", columns,[]);
			ret.isFetching = false;
			return ret;
		case FETCH_CSV_TEMPLATE_INFO:
			ret.isFetching = true;
			return ret;
		case FAIL_FETCH_CSV_TEMPLATE_INFO:
			ret.isProcessError = true;
			ret.isFetching = false;
			return ret;
		case SUCCESS_FETCH_CSV_TEMPLATE_INFO:
			ret.isFetching = false;
			ret.csvTemplateList = action.payload.data;
			return ret;
		case RESET_PROCESS_ERROR:
			ret.isProcessError = false;
			return ret;
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/upload.js